import T from 'utils/T';
import ex from 'utils/ex';

import PatientAge from './PatientAge';
import PatientSex from './PatientSex';
import PatientDeseaseInfo from './PatientDeseaseInfo';
import PatientPhysicalInfo from './PatientPhysicalInfo';

export default function PatientStatus(props) {
  return (
    <div {...ex('PatientStatus', props)}>
      <div>
        <PatientAge {...props} />
        ｜
        <PatientSex  {...props} />
        ｜
        <PatientDeseaseInfo  {...props} />
      </div>
      <div>
        <PatientPhysicalInfo  {...props} />
      </div>
    </div>
  );
}

